module.exports = __webpack_public_path__ + "img/fruit_apple.1dd85971.png";